export default __webpack_public_path__ + "static/90a3977d47fa2202e017c714e1124829.png";